export class LatLng{
  constructor(public latitude: number, public longitude: number){}
}

